import { FirmUnderwriterItem } from 'api/admin/types';

export interface UnderwriterOption {
  name: string;
  value: string;
}

// First American underwriters arrive without IsSelected, which makes them always available.
// Additional underwriters carry IsSelected, and the firm has opted out of the ones set to false.
export function buildFirmUnderwriterOptions(underwriters?: FirmUnderwriterItem[]): UnderwriterOption[] {
  const availableUnderwriters = (underwriters ?? []).filter((underwriter) => underwriter.IsSelected !== false);

  const firstAmerican = availableUnderwriters.filter((underwriter) => !underwriter.IsExternalUnderwriter);
  const additional = availableUnderwriters
    .filter((underwriter) => underwriter.IsExternalUnderwriter)
    .sort((a, b) => a.Name.localeCompare(b.Name));

  return [...firstAmerican, ...additional].map((underwriter) => ({
    name: underwriter.Name,
    value: underwriter.Code,
  }));
}
